
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";

import { TipoDependenciaProps } from "./TipoDependenciaInterface";
import { defaultDomicilio, DomicilioProps } from "../comun/DomicilioInterface";

// definición de defaults

export const defaultDependencia: DependenciaProps = { idDependencia: 0, descripcion : '', activo: false, }

export const defaultAgregarDomicilioDependencia: AgregarDomicilioDependenciaResponse = {
    ...defaultHttpResponse,
    domicilio:      defaultDomicilio,
}

//Creación de interfaces

export interface DependenciaProps {
    idDependencia:      number;
    descripcion:        string;
    activo:             boolean;
    idTipoDependencia?: number;
    tipoDependencia?:   TipoDependenciaProps;
}

export interface AgregarDomicilioDependenciaParams {
    idDependencia:      number;
    descripcion:        string;
    numero:             string;
    referencia:         string;
    idAsentamiento:     number;
    idTipoDomicilio:    number;
}

export interface AgregarDomicilioDependenciaResponse extends HttpResponse {
    domicilio:      DomicilioProps;
}